import { makeStyles, Theme } from '@material-ui/core/styles'

export const useNewsStyles = makeStyles<Theme>((theme) => ({
  main: {
    gap: '2.5rem',
    width: '100%',
    display: 'flex',
    padding: `2.5rem .5rem`,
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'center',
    backgroundColor: theme.palette.common.white,
  },
  title: {
    fontWeight: 700,
    textAlign: 'center',
    textTransform: 'uppercase',
    color: theme.palette.primary.main,
    fontSize: theme.typography.pxToRem(30),
    [theme.breakpoints.down('sm')]: {
      fontSize: theme.typography.pxToRem(24),
    },
  },
  button: {
    width: '100%',
    backgroundColor: theme.palette.primary.main,
    color: '#fff',
    maxWidth: 200,
    height: 46,
    transition: 'opacity 0.3s ease',
    borderRadius: 0,
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
      opacity: '0.8',
    },
  },
  textButton: {
    fontWeight: 700,
    fontSize: theme.typography.pxToRem(14),
    textTransform: 'uppercase',
  },
  image: {
    width: '100%',
    maxWidth: '380px',
    height: '248px',
    maxHeight: '248px',
    objectFit: 'cover',
    objectPosition: 'center',
  },
  newsContainer: {
    gap: '2rem',
    width: '100%',
    display: 'flex',
    maxWidth: '1290px',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  topContainerNews: {
    gap: '1rem',
    width: '100%',
    display: 'flex',
    alignItems: 'top',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  topNews: {
    width: '100%',
    maxWidth: '380px',
    height: '100%',
    minHeight: '312px',
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'column',
  },
  topNewsTitle: {
    fontSize: theme.typography.pxToRem(18),
    paddingTop: theme.typography.pxToRem(16),
    fontWeight: 600,
    color: '#626E71',
    fontFamily: 'Roboto',
    lineHeight: '24px',
    letterSpacing: '0.035em',
    textAlign: 'left',
    textUnderlinePosition: 'fromfont',
    textDecorationSkipInk: 'none',
  },
  topNewsTitleBox: {
    width: '100%',
    maxWidth: '380px',
  },
  bottonGruoupNews: {
    gap: '2rem',
    width: '100%',
    maxWidth: '30%',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  bottonNews: {
    gap: '1rem',
    width: '100%',
    display: 'flex',
    cursor: 'pointer',
    alignItems: 'center',
    flexDirection: 'row',
  },
  bottonImage: {
    minWidth: '188px',
    height: '120px',
    maxHeight: '120px',
  },
  bottonNewsTitle: {
    fontSize: theme.typography.pxToRem(16),
    fontWeight: 400,
    color: '#626E71',
    fontFamily: 'Roboto',
    lineHeight: '16px',
    letterSpacing: '0.035em',
    textDecorationSkipInk: 'none',
  },
}))
